import type { Fallacy } from "./types";
import { createStory } from "./types";

export const viralEqualsTrue: Fallacy = {
    id: "viral-equals-true",
    name: "Viral = True",
    emoji: "📱",
    category: "Jebakan Digital",
    description:
      "Menganggap sesuatu benar karena **banyak yang share**. Padahal viralitas ditentukan oleh emosi, **bukan akurasi fakta**.",
    tldr: "Viral bukan berarti benar — hoaks justru lebih cepat menyebar daripada fakta.",
    detail:
      "Viral = True adalah bias yang kuat di era media sosial. Logikanya sederhana tapi keliru: 'Kalau banyak yang share, pasti ada benarnya.' Nyatanya, riset MIT menunjukkan **berita palsu menyebar 6 kali lebih cepat** daripada berita benar.\n\nKenapa hoaks lebih viral? Karena konten yang **memicu emosi kuat** — marah, takut, kaget — jauh lebih sering di-share. **Algoritma media sosial memprioritaskan engagement, bukan kebenaran**.\n\nDi grup WhatsApp keluarga, ini jadi senjata andalan: 'Tante juga dapat dari grup sebelah, berarti memang benar.' Seolah-olah **jumlah forward adalah bukti kebenaran**.\n\nCara melawan: Selalu **cek sumber aslinya**. Jumlah share, views, atau forward bukan indikator kebenaran.",
    story: createStory("Viral = True", "📱", {
      hook: {
        title: "\"8 juta orang share, masa salah?\"",
        body: "Riset MIT bilang hoaks menyebar **6 kali lebih cepat** dari fakta. Jadi... iya, bisa salah.",
      },
      convo: {
        claim: "Info minum air lemon larutin batu ginjal belum terbukti medis, tapi videonya udah ditonton 12 juta kali. **Kalo hoaks gak mungkin sebanyak itu yang percaya.**",
        response: "Yang viral itu yang bikin penasaran, bukan yang bener. **Views bukan validasi medis.**",
      },
      reveal: {
        body: "Kamu nganggep sesuatu bener karena **banyak yang share**. Padahal viralitas ditentukan oleh **emosi, bukan akurasi**.",
      },
      insight: {
        title: "Kenapa hoaks lebih viral?",
        body: "Konten yang bikin **marah, takut, atau kaget** lebih sering di-share. Algoritma promosiin yang engaging — **bukan yang bener**.",
      },
      engagement: {
        title: "Pernah hampir percaya info cuma karena viral? 📱",
        body: "Tips kesehatan atau berita politik? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["bandwagon", "appeal-to-authority", "hasty-generalization"],
  };
